<template>
  <div class="view-register">
    <p class="mb-3">
      Criar conta
    </p>
    <form v-show="step == 1" @submit.prevent="next">
      <form-group
        v-model="form.name"
        id="name"
        label="Nome completo"
        type="text"
        icon="fa-regular fa-user"
        placeholder="Digite o seu nome"
        :errors="errors.name"
        autoCheck
        @setError="setError"
      />

      <form-group
        v-model="form.email"
        id="email"
        type="email"
        label="E-mail"
        icon="fa-regular fa-envelope"
        placeholder="Digite o seu e-mail"
        :errors="errors.email"
        autoCheck
        @setError="setError"
      />

      <form-group
        v-model="form.password"
        id="password"
        type="password"
        label="Senha"
        icon="fa-regular fa-key"
        placeholder="Crie uma senha de acesso"
        :errors="errors.password"
        autoCheck
        @setError="setError"
        disableAutocomplete
        disableAutocapitalize
      />

      <form-group
        v-model="form.confirm_password"
        id="confirm_password"
        type="password"
        label="Senha"
        icon="fa-regular fa-key"
        placeholder="Confirme sua senha de acesso"
        :errors="errors.confirm_password"
        autoCheck
        @setError="setError"
        disableAutocomplete
        disableAutocapitalize
      />
      <auth-button text="Próximo" class="mt-6 pt-5" :loading="loading" />
    </form>
    <form v-show="step == 2" @submit.prevent="submit">
      <!-- <form-group
          v-model="form.phone"
          id="phone"
          type="tel"
          is-phone
          label="WhatsApp para suporte"
          placeholder="Número do WhatsApp"
          :errors="errors.phone"
          @country-changed="phoneCountryChanged"
          /> -->
      <form-group
        v-model="form.phone"
        id="phone"
        type="tel"
        label="WhatsApp para suporte"
        icon="fa-brands fa-whatsapp"
        mask="(##) #####-####"
        placeholder="Número de WhatsApp"
        :errors="errors.phone"
      />
      <form-group
        v-model="form.instagram"
        id="instagram"
        label="Instagram"
        icon="fa-brands fa-instagram"
        placeholder="Conta do Instagram"
        :errors="errors.instagram"
      />

      <!-- <form-group
        v-model="form.segment"
        id="segment"
        select
        label="Qual o seu objetivo?"
        placeholder="Selecione..."
        :errors="errors.segment"
        :options="[
          { id: 'sell', name: 'Vender Produtos' },
          { id: 'buy', name: 'Comprar Produtos' }
        ]"
        auth
      /> -->

      <b-form-checkbox
        id="terms"
        v-model="terms"
        name="terms"
        :value="true"
        class="mt-5"
      >
        Declaro que concordo com os
        <a
          :href="`https://pay.${$config.domain}/termos-de-uso`"
          target="_blank"
          style="color: #bb87ff"
        >
          Termos de uso </a
        >, estou ciente da
        <a
          :href="`https://pay.${$config.domain}/politica-de-privacidade`"
          target="_blank"
          style="color: #bb87ff"
        >
          Política de privacidade
        </a>
        da {{ $config.get("title") }} e sou maior de idade de acordo com a
        legislação aplicável.
      </b-form-checkbox>
      <auth-button
        text="Concluir"
        class="mt-5 pt-3"
        :loading="loading"
        :disabled="!terms || loading"
      />
    </form>
    <p class="text-center text-white fs-16 mt-6">
      <router-link class="main" :to="{ name: 'login' }">
        Voltar para login
      </router-link>
    </p>

    <div class="footer fs-14">
      Este site é protegido por reCAPTCHA e a
      <a target="_blank" href="https://policies.google.com/privacy">
        Política de Privacidade
      </a>
      e os
      <a target="_blank" href="https://policies.google.com/terms">
        Termos de Serviço
      </a>
      do Google se aplicam.
    </div>
  </div>
</template>

<script>
import AuthButton from "@/components/auth/AuthButton.vue";
import { formFields } from "@/functions/helpers.js";

export default {
  components: { AuthButton },
  data() {
    return {
      ...formFields([
        "name",
        "email",
        "password",
        "confirm_password",
        "phone",
        "segment",
        "instagram"
      ]),
      terms: false,
      loading: false,
      ddi: 55,
      step: 1
    };
  },
  methods: {
    // phoneCountryChanged(obj) {
    //   this.ddi = obj.dialCode;
    // },
    setError(error, field) {
      this.errors[field] = error;
    },
    login() {
      this.$router.push({ name: "login" });
    },
    next() {
      this.step = 2;
    },
    submit() {
      this.$message.hide();
      this.loading = true;

      window.grecaptcha
        .execute({ action: "submit" })
        .then(token => {
          this._submit(token);
        })
        .catch(() => {
          this.loading = false;
          this.$message.error("Por favor, tente novamente");
        });
    },
    _submit(recaptcha_token) {
      const data = { ...this.form, recaptcha_token };
      if (data.phone) {
        data.phone = `${this.ddi}${data.phone}`;
      }
      data.segment = "sell";
      data.query_params = this.$route.query;

      if (this.form.password !== this.form.confirm_password) {
        this.errors.confirm_password = [
          "A senha de confirmação deve ser igual a senha"
        ];
        this.step = 1;
        this.loading = false;
        return;
      }

      this.$store
        .dispatch("user/register", data)
        .then(response => {
          this.$store.dispatch("postLogin").catch(() => {
            this.$router.replace({
              name: "login",
              query: { path: this.$route.fullPath }
            });
          });
          this.$router.push({ name: "home", params: { first_access: true } });
          this.$dataLayer.push({
            event: "generate-lead",
            name: response.name,
            email: response.email,
            phone: response.phone
          });
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          } else if (this.errors.message) {
            this.$message.error(this.errors.message);
          }
          if (
            this.errors.name ||
            this.errors.email ||
            this.errors.password ||
            this.errors.confirm_password
          ) {
            this.step = 1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-register {
  color: var(--semantic-neutral-600, #c7c7c7);
  ::v-deep {
    .custom-control-label::before {
      background: transparent !important;
      border: #adb5bd solid 1px !important;
      box-shadow: unset;
    }
  }
  .footer {
    margin-top: 20px;
    text-align: center;
    font-size: 16px;
    color: var(--semantic-neutral-600, #c7c7c7);
    a {
      color: #fff;
    }
  }
}
</style>
